
import React, { useEffect, useState } from "react";
import { KoButton, KoImage, KoLoader, KoModal, KoNano, KoText, KoTitle, Radio } from "packages";
import { load } from '@cashfreepayments/cashfree-js';
// import { useSelector } from "react-redux";
import styles from "./subscriptions.module.scss";
import { subscriptionAPI } from "./subscriptions.service";


export default function Subscriptions({openSunscriptions, setOpenSubscriptions}) {
  const [isLoading, setLoading] = useState(false);
  const [cashfree, setCashfree] = useState(null);
  const [planList, setPlanList] = useState([]);

  const [isAnnual, setIsAnnual] = useState(1);

  
  const [plans, setPlans] = useState([
    { name: "Free", monthly: 0, annualDiscount: 0 },
    { name: "Launch", monthly: 13, annualDiscount: 6 },
    { name: "Growth", monthly: 30, annualDiscount: 9 }
  ]);
  // const userById = useSelector(state => state?.userById);
  // const accountById = useSelector(state => state?.accountById);
  // const accountDetails = accountById['data'];
  // const subscription = useSelector(state => state.subscription);
  // let userDetails = userById['data'];

  useEffect(() => {
    getPlans();
    initializeCashfreeSDK();
  }, []);


  const getPlans = async() => {
    try {
      setLoading(true);
      const response = await subscriptionAPI.getPlans();
      setPlanList(response.data);
      setLoading(false);
      console.error(planList);
    } catch (error) {
      console.error(error, planList);
      setLoading(false);
    }
  };
    
  const initializeCashfreeSDK = async() => {
    try {
      const instance = await load({ mode: 'sandbox' });
      setCashfree(instance);
    } catch (err) {
      console.error('Cashfree init failed:', err);
    }
  };

  const Launch = [
    {
      module: "WORKSPACES",
      Submodule: [
        { plan: " Development" },
        { plan: "Helpdesk" },
        { plan: "Orders" },
        { plan: "Support" },
        { plan: "Sales" },
        { plan: "Marketing" },
        { plan: "Finance" },
        { plan: "HR" },
        { plan: "Assets" },
        { plan: "30 Workspaces included · Expand anytime" }
      ]
    },
    {
      module: "DRIVE",
      Submodule: [
        { plan: " MyDrive · Recent · Shared · Bin" },
        { plan: "20 GB included | + 10 GB = $9 / month" }
      ]
    },
    {
      module: "ENGAGEMENTS",
      Submodule: [
        { plan: "Calendar . Events" },
        { plan: "Integrations Google, Microsoft" }
      ]
    },
    {
      module: "ORGANIZATION",
      Submodule: [
        { plan: "Peoples . Groups" },
        { plan: "Designations . Departments" }
      ]
    },
    {
      module: "CUSTOMER",
      
      Submodule: [
        { plan: "Dashboard . Leads . Clients" },
        { plan: "Notification Templates" },
        { plan: "Workflow . Account Types" },
        { plan: "199 included · +$2 / user / month" }
      ]
    },
    {
      module: "ADMIN CONSOLE",
      Submodule: [{ plan: "Holidays Config . Account Settings" }]
    }
  ];

  const options = [
    { label: "Annual billing", value: 1, className: "label-1" },
    { label: "Monthly billing", value: 2, className: "label-2" }
  ];
  const Growth = [
    {
      module: "WORKSPACES",
      Submodule: [
        { plan: " Launch +" },
        { plan: "50 Workspaces included · Expand anytime" }
      ]
    },
    {
      module: "DRIVE",
      Submodule: [
        { plan: " Launch +" },
        { plan: "30 GB included | + 10 GB = $9 / month" }
      ]
    },
    {
      module: "ENGAGEMENTS",
      Submodule: [
        { plan: "Launch +" },
        { plan: "Integrations Google, Microsoft, Zoom" }
      ]
    },
    {
      module: "ORGANIZATION",
      Submodule: [
        { plan: "Peoples . Groups" },
        { plan: "Designations . Departments" }
      ]
    },
    {
      module: "CUSTOMER",
      Submodule: [
        { plan: "Launch +" },
        { plan: "499 included · +$2 / user / month" }
      ]
    },
    {
      module: "ADMIN CONSOLE",
      Submodule: [{ plan: "Launch +" }]
    }
  ];

  const customPricing = [
    {
      module: "WORKSPACES",
      Submodule: [
        { plan: " Growth +" },
        { plan: "Unlimited Workspaces" }
      ]
    },
    {
      module: "DRIVE",
      Submodule: [
        { plan: " Growth +" },
        { plan: "Unlimited Storage" }
      ]
    },
    {
      module: "ENGAGEMENTS",
      Submodule: [
        { plan: "Growth +" },
        { plan: "Unlimited Integrations" }
      ]
    },
    {
      module: "ORGANIZATION",
      Submodule: [
        { plan: "Growth +" },
        { plan: "Customization" }
      ]
    },
    {
      module: "CUSTOMER",
      Submodule: [
        { plan: "Growth +" },
        { plan: "unlimited Customers" }
      ]
    },
    {
      module: "ADMIN CONSOLE",
      Submodule: [ { plan: "Growth +" }]
    }
  ];


  const onChangePlans = ({ target: { value } }) => {
    setIsAnnual(value);
    setPlans(plans);
  };

  const calculatePrice = (plan) => {
    if (isAnnual === 1) return plan.monthly * 12 - plan.annualDiscount;
    return plan.monthly;
  
  };

  const buildCashfreePayload = (plan) => {
    const isMonthly = isAnnual === 2;
    const amount = plan.amount || 0;

    return {
      plan_details:{
        plan_id: plan.planId
      },
      subscription_id:KoNano('SUB'),
    
      plan_name: plan.planName === "1" ? "Launch Plan" : "Growth Plan",
      plan_amount: amount,
      plan_interval_type: isMonthly ? "MONTH" : "YEAR"
     
    };
  };

  const handleUpgradeNow = async(plan) => {
    if (!plan || !cashfree) return;

    try {
      setLoading(true);

      const payload = buildCashfreePayload(plan);
      const res = await subscriptionAPI.createSubscription(payload?.plan_id, payload);
      const { payment_session_id } = res?.data || {};

      if (!payment_session_id) {
        throw new Error("Payment session not created");
      }

      await cashfree.checkout({
        paymentSessionId: payment_session_id,
        redirectTarget: "_self"
      });

    } catch (err) {
      console.error("Payment failed:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <KoModal
      title={`Upgrade Your Plan`}
      centered
      open={openSunscriptions}
      afterClose={() => {
        setOpenSubscriptions();
      }}
      handleOk={() => {
        setOpenSubscriptions();
      }}
      onClose={() => {
        setOpenSubscriptions();
      }}
      width={"75vw"}
      footer={[
        <KoButton
          key="cancel"
          label="Close"
          onClick={() => {
            setOpenSubscriptions(false);
          }}
        />
      ]}
    >
      <div className={styles.wrapper}>
        {isLoading && <KoLoader/>}
        <div className={styles.pricingSection}>
          <div className={styles.header}>
            <div className={styles.leftheader}>
              <KoTitle
                level={1}
                className={styles.pricingTitle}
                text={"Plans & "}
              />
              <KoTitle
                level={1}
                className={styles.pricingTitle}
                text={"Pricing "}
              />
              <div className={styles.titleContent}>
                <KoTitle
                  text={`Start your 14-day free trial today`}
                  level={3}
                  className={styles.pricingTitleTrail}
                />
                <KoTitle
                  text={`Launch faster, collaborate smarter, and automate more upgraded teams grow 4× faster.`}
                  level={3}
                />
                <div className={styles.comparePlans}>
                  <KoButton
                    type={"primary"}
                    className={styles.comparePlanBtn}
                    label={"COMPARE PLANS"}
                  />
                  <Radio.Group
                    options={options}
                    value={isAnnual}
                    onChange={onChangePlans}
                    optionType="button"
                    buttonStyle="solid"
                  />
                </div>
              </div>
            </div>
            <div className={styles.rightheader}>
              <div className={styles.circleone}>
                <KoImage
                  className={styles.imageone}
                  alt={"name"}
                  src={`/images/profile.jpg`}
                  width={350}
                  height={110}
                  preview={false}
                />              </div>
              <div className={styles.circletwo}></div>
              <div className={styles.circlethree}>
                <KoImage
                  className={styles.imageone}
                  alt={"name"}
                  src={`/images/profiles.png`}
                  width={450}
                  height={200}
                  preview={false}
                />
              </div>
              <div className={styles.circlefour}></div>
              <div className={styles.circlefive}></div>
            </div>
          </div>
          <div>
          </div>
          <div className={styles.upgradePlans}>
            <div className={styles.subscriptions}>
              <div className={styles.plan}>
                <KoTitle className={styles.textColor} text={`$${calculatePrice(plans[1])} ${isAnnual === 1 ?"/year" : "/month"}`} level={1} />
                <KoTitle
                  className={styles.textColor}
                  text={`Launch `}
                  level={1}
                />
                <KoTitle
                  className={styles.textColor}
                  text={`For growing teams up to 29`}
                  level={5}
                />
                <KoText
                  className={styles.textColor}
                  text={`Get started easily, keep your team coordinated, manage tasks efficiently, and complete projects on time without hassle.`}
                />
                <div className={styles.choosePlan}>
                  <KoButton label="CHOOSE PLAN" type="primary" onClick={()=>handleUpgradeNow({
                    amount:calculatePrice(plans[1]),
                    planName:'1',
                    planId: 'p_1',
                    plan:isAnnual
                  })} />
                </div>
              </div>
              <div className={styles.listofAcess}>

                {Launch.map((item, index) => (
                  <div key={`module-${index}`}>
                    <KoTitle className={styles.titleList} level={5} text={item.module} />

                    {item.Submodule.map((sub, subIndex) => (
                      <div
                        className={styles.tickGrid}
                        key={`sub-${index}-${subIndex}`}
                      >
                        <KoText text={sub.plan} />
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>

            <div className={styles.subscriptions}>
              <div className={styles.plan}>
                <KoTitle className={styles.textColor} text={`$${calculatePrice(plans[2])} ${isAnnual === 1 ?"/year" : "/month"}`} level={1} />
                <KoTitle
                  className={styles.textColor}
                  text={`Growth `}
                  level={1}
                />
                <KoTitle
                  className={styles.textColor}
                  text={`For scaling organizations up to 99`}
                  level={5}
                />
                <KoText
                  className={styles.textColor}
                  text={`Boost your team’s productivity, track progress clearly, streamline operations, and make smarter business decisions every day.`}
                />
                <div className={styles.choosePlan}>
                  <KoButton label="CHOOSE PLAN" type="primary" onClick={()=>handleUpgradeNow({
                    amount:calculatePrice(plans[2]),
                    plan:isAnnual,
                    planId: 'plan_002',
                    planName:'2'
                  })} />
                </div>
              </div>
              <div className={styles.listofAcess}>

                {Growth.map((item, index) => (
                  <div key={`module-${index}`}>
                    <KoTitle level={5} text={item.module} />

                    {item.Submodule.map((sub, subIndex) => (
                      <div
                        className={styles.tickGrid}
                        key={`sub-${index}-${subIndex}`}
                      >
                        <KoText text={sub.plan} />
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
            <div className={styles.subscriptions}>
              <div className={styles.plan}>
                <KoTitle
                  className={styles.textColor}
                  text={`Custom Pricing`}
                  level={1}
                />
                <KoTitle className={styles.textColor} text={`Scale `} level={1} />
                <KoTitle
                  className={styles.textColor}
                  text={`For large-scale deployments`}
                  level={5}
                />
                <KoText
                  className={styles.textColor}
                  text={`Design a custom system for your organization, simplify complex workflows, secure your data, and improve overall operational efficiency.`}
                />
                <div className={styles.choosePlan}>
                  <KoButton label="TALK TO SALES" type="default" onClick={()=>handleUpgradeNow()} />
                </div>
              </div>
              <div className={styles.listofAcess}>

                {customPricing.map((item, index) => (
                  <div key={`module-${index}`}>
                    <KoTitle level={5} text={item.module} />

                    {item.Submodule.map((sub, subIndex) => (
                      <div
                        className={styles.tickGrid}
                        key={`sub-${index}-${subIndex}`}
                      >
                        <KoText text={sub.plan} />
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </KoModal>
  );
}
